import system from "./system";

const components = {
  button: {
    fontFamily: system.fonts.body,
    fontSize: "18px",
    border: `2px solid ${system.colors.text.primary}`,
    color: system.colors.text.primary,
  },
  divider: {
    backgroundColor: system.colors.text.primary,
  },
  loading: {
    color: system.colors.text.primary,
  },
  pageHeader: {
    fontFamily: '"Rubik Wet Paint", "Noto Serif JP", serif',
    color: system.colors.text.primary,
    fontSize: "24px",
    fontWeight: "bold",
  },
  sectionHeader: {
    fontFamily: '"Rubik Wet Paint", "Noto Serif JP", serif',
    color: system.colors.text.primary,
    fontSize: "36px",
    fontWeight: "bold",
  },
  footer: {
    color: system.colors.text.primary,
    fontFamily: system.fonts.body,
    fontSize: "16px",
    fontWeight: "bold",
  },
  howToUseSlider: {
    paper: {
      border: `1px solid ${system.colors.text.primary}`,
      borderRadius: 2,
      backgroundColor: "rgba(255, 255, 255, 0.0)",
    },
    overlay: {
      borderRadius: 1,
      backgroundColor: "rgba(255, 255, 255, 0.6)",
    },
    bullet: {
      active: "#AD3D48",
      inactive: "#C96B6B",
    },
    text: {
      point: {
        fontSize: "16px",
        fontWeight: "bold",
        fontFamily: '"Noto Serif JP", serif',
      },
      title: {
        fontSize: "19px",
        fontWeight: "bold",
        fontFamily: '"Noto Serif JP", serif',
      },
      description: {
        fontSize: "15px",
        fontFamily: '"Noto Serif JP", serif',
      },
    },
  },
  newsItem: {
    text: {
      title: {
        fontFamily: system.fonts.body,
        color: system.colors.text.primary,
        fontSize: "14px",
      },
      date: {
        fontFamily: system.fonts.body,
        color: system.colors.text.secondary,
        fontSize: "12px",
      },
    },
  },
  myPageCard: {
    paper: {
      borderRadius: 1,
      backgroundColor: "rgba(255, 255, 255, 0.3)",
      boxShadow: "0px 0px 16px rgba(173, 61, 72, 0.75)",
    },
    text: {
      name: {
        fontFamily: `Kaisei Tokumin, serif`,
        fontSize: "18px",
        fontWeight: 700,
        color: "black",
      },
      remainingDays: {
        fontFamily: `Kiwi Maru, serif`,
        fontSize: "12px",
        fontWeight: "bold",
        color: "black",
      },
      description: {
        fontFamily: `Kiwi Maru, serif`,
        fontSize: "15px",
        color: "black",
      },
    },
  },
  questCard: {
    paper: {
      borderRadius: 4,
      border: `1px solid ${system.colors.text.primary}`,
      backgroundColor: system.colors.background.card,
      boxShadow: "0px 0px 4px rgba(200, 200, 200, 0.5)",
    },
    text: {
      name: {
        fontFamily: '"Kaisei Tokumin"',
        fontWeight: 700,
        fontSize: "17px",
        color: "#333333",
      },
      description: {
        fontFamily: system.fonts.body,
        fontSize: "12px",
        color: "#333333",
      },
    },
    lockIcon: {
      color: "gray",
    },
    chip: {
      cleared: {
        fontWeight: 700,
        color: system.colors.text.primary, // 文字の色を指定
        backgroundColor: "rgba(231, 226, 239, 0.5)",
        boxShadow: "0px 4px 8px rgba(125, 125, 125, 0.75)",
        fontFamily: '"Kaisei Decol", serif',
      },
      uncleared: {
        fontWeight: 700,
        color: system.colors.text.primary,
        backgroundColor: "rgba(255, 252, 194, 0.5)",
        boxShadow: "0px 4px 8px rgba(125, 125, 125, 0.75)",
        fontFamily: '"Kaisei Decol", serif',
      },
    },
  },
  ticketBox: {
    text: {
      name: {
        fontFamily: system.fonts.heading,
        fontSize: "22px",
        fontWeight: "bold",
        color: system.colors.text.primary,
      },
      description: {
        fontFamily: system.fonts.body,
        fontSize: "14px",
        color: system.colors.text.primary,
      },
      price: {
        fontFamily: system.fonts.heading,
        fontSize: "22px",
        fontWeight: "bold",
        color: system.colors.text.primary,
      },
      notice: {
        fontFamily: system.fonts.body,
        fontSize: "13px",
        fontWeight: "bold",
        color: system.colors.text.primary,
      },
    },
  },
  storySection: {
    name: {
      fontFamily: system.fonts.body,
      fontSize: "14px",
      fontWeight: "bold",
      color: system.colors.text.primary,
    },
    story: {
      fontFamily: system.fonts.body,
      fontSize: "18px",
      color: system.colors.text.primary,
      lineHeight: "1.8",
    },
  },
  questRewardBox: {
    paper: {
      backgroundColor: "rgba(105, 105, 105, 0.2)", // 黒い透明レイヤー
      borderRadius: "4px",
    },
    lockIcon: {
      color: "gray",
    },
  },
  dialog: {
    title: {
      fontFamily: system.fonts.heading,
      fontSize: "16px",
      color: system.colors.text.primary,
    },
    description: {
      fontFamily: system.fonts.body,
      fontSize: "14px",
      color: system.colors.text.primary,
    },
    width: "80%",
    backgroundColor: "#FEFEFE",
    button: {
      color: system.colors.text.primary,
    },
  },
};

export default components;
